module.exports = __webpack_public_path__ + "fonts/AdelleSansSAGE.5a1a5c5a.woff";